import ImageCarouselNav from './ImageCarouselNav.jsx';

export default ImageCarouselNav;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/ImageCarouselNav/index.js